export default __webpack_public_path__ + "static/media/Tracy.2358dbe2.jpg";